// extracted by mini-css-extract-plugin
export default {"content":"form_content__tcFtK","form":"form_form__3TBro","title":"form_title__uXhLH","toggle":"form_toggle__Bw-J4"};